module.exports = __webpack_public_path__ + "src/img/shuju.bd3a2940.svg";